module.exports = __webpack_public_path__ + "img/zfb.a6f56f32.jpg";